export default {
    serviceGroups: 'گروه های خدمات',
    serviceGroupsTitle: 'عنوان',
    serviceGroupsStatus: 'وضعیت',
    editServiceGroups: 'ویرایش گروه های خدمات',
    addServiceGroups: ' گروه های خدمات جدید',

}